import { render } from "./EmergencyModal.vue?vue&type=template&id=5c189e03"
import script from "./EmergencyModal.vue?vue&type=script&lang=js"
export * from "./EmergencyModal.vue?vue&type=script&lang=js"

import "./EmergencyModal.vue?vue&type=style&index=0&id=5c189e03&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__